// extracted by mini-css-extract-plugin
export default {"edit":"Edit_edit__+Uf-F","title":"Edit_title__KcCsF"};